import React from 'react';

import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';

import { GridApi } from 'ag-grid-community';
import { BaseAgGrid } from 'src/components/BaseAgGrid';
import { AppContext } from 'src/contexts/appContext';
import { IRateCardGridRowData } from 'src/types/IRateCard';

import { getCppMauColDefs, showPlayCustomerProgramTypeCols } from '../cppMauColDefs';
import './ViewMauGrid.scss';

interface IViewMauGridProps {
    mauRowData: IRateCardGridRowData[];
    filterText: string;
    setMauGridApi: React.Dispatch<React.SetStateAction<GridApi | undefined>>;
    dataLoaded?: boolean;
}

export const ViewMauGrid = ({ mauRowData, filterText, setMauGridApi, dataLoaded = true }: IViewMauGridProps) => {
    const { metadata } = React.useContext(AppContext);
    const colDefs = getCppMauColDefs(metadata.territoryMapping);

    showPlayCustomerProgramTypeCols(mauRowData, colDefs, true);

    return (
        <Column heights={['fit', 'fill']} minHeight={'300px'}>
            <Text type="h400">Monthly active user</Text>
            <BaseAgGrid
                columnDefs={colDefs}
                rowData={mauRowData}
                suppressRowClickSelection={true}
                filterText={filterText}
                setAgGridApi={setMauGridApi}
                loading={!dataLoaded}
            />
        </Column>
    );
};
